<script setup>
import { computed } from 'vue';

import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  call: { type: Object, required: true },
});

const presentation = computed(() => {
  const videoLabel = props.call.video ? 'görüntülü' : 'sesli';
  const byKind = {
    received: {
      title: `Gelen ${videoLabel} arama`,
      detail: 'WhatsApp arama kaydı',
      icon: 'i-lucide-phone-incoming',
      tone: 'text-n-teal-11 bg-n-teal-9/10',
    },
    accepted: {
      title: `${videoLabel[0].toUpperCase()}${videoLabel.slice(1)} arama yanıtlandı`,
      detail: 'Diğer WhatsApp cihazında yanıtlandı',
      icon: 'i-lucide-phone-call',
      tone: 'text-n-blue-11 bg-n-blue-9/10',
    },
    missed: {
      title: `Cevapsız ${videoLabel} arama`,
      detail: 'WhatsApp arama kaydı',
      icon: 'i-lucide-phone-missed',
      tone: 'text-n-ruby-11 bg-n-ruby-9/10',
    },
    incoming: {
      title: `Gelen ${videoLabel} arama`,
      detail: 'WhatsApp arama kaydı',
      icon: 'i-lucide-phone-incoming',
      tone: 'text-n-teal-11 bg-n-teal-9/10',
    },
    outgoing: {
      title: `Yapılan ${videoLabel} arama`,
      detail: 'WhatsApp arama kaydı',
      icon: 'i-lucide-phone-outgoing',
      tone: 'text-n-blue-11 bg-n-blue-9/10',
    },
    legacy: {
      title: 'WhatsApp araması',
      detail: 'Geçmişten aktarılan arama kaydı',
      icon: 'i-lucide-phone-call',
      tone: 'text-n-teal-11 bg-n-teal-9/10',
    },
  };
  return byKind[props.call.kind] || byKind.incoming;
});

const durationLabel = computed(() => {
  const seconds = props.call.duration;
  if (!Number.isFinite(seconds) || seconds <= 0) return '';
  const minutes = Math.floor(seconds / 60);
  const remainder = Math.floor(seconds % 60);
  return minutes > 0 ? `${minutes} dk ${remainder} sn` : `${remainder} sn`;
});
</script>

<template>
  <article
    class="flex min-w-64 items-center gap-3 rounded-xl border border-n-container bg-n-alpha-2 p-3"
    :aria-label="presentation.title"
  >
    <div
      class="grid size-10 shrink-0 place-content-center rounded-full"
      :class="presentation.tone"
    >
      <Icon :icon="presentation.icon" class="size-5" />
    </div>
    <div class="min-w-0 flex-1">
      <p class="truncate font-medium text-n-slate-12">
        {{ presentation.title }}
      </p>
      <p class="truncate text-xs text-n-slate-11">
        {{ durationLabel || presentation.detail }}
      </p>
    </div>
    <Icon
      :icon="call.video ? 'i-lucide-video' : 'i-lucide-phone'"
      class="size-4 shrink-0 text-n-slate-10"
      aria-hidden="true"
    />
  </article>
</template>
